import "./App.scss";
import Header from "./views/header/Header";
import Navbar from "./views/navbar/Navbar";
import Banner from "./views/banner/Banner";
import Reviews from "./views/reviews/Reviews";
import Footer from "./views/footer/Footer";
import MainPage from "./views/mainPage/MainPage";
import ProductPage from "./views/productPage/ProductPage";
import { Routes, Route } from "react-router-dom";
import { PRODUCT } from "../urls";
// import Preloader from "./reusable/preloader/Preloader";

const App = () => (
  <div className="App">
    <Header />
    <main className="App-content">
      <Routes>
        <Route path="/" element={
          <>
            <Navbar />
            <Banner />
            <MainPage />
            <Reviews />
          </>
        } />
        <Route path={PRODUCT} element={<ProductPage />} />
      </Routes>
    </main>
    <Footer />
  </div>
);

export default App;
